import useSWRImmutable from 'swr/immutable'
import { endpoints, request } from '#services'

/**
 * @typedef {Object} UsePopResult
 * @property {object|undefined} data - The post or page data (WordPress REST API object).
 * @property {any} isError - Error object if the request failed.
 * @property {boolean} isLoading - Loading state.
 * @property {function} mutate - Function to revalidate the data.
 * @property {boolean} isValidating - Validation state.
 */

/**
 * React hook to fetch a post or page from the WordPress REST API.
 * @param {object} params - Parameters for fetching a post or page.
 * @param {number} params.id - The post or page ID.
 * @param {string} params.type - The type: 'post' or 'page'.
 * @returns {UsePopResult}
 */
export const usePop = ({ id, type }) => {
  const { data, error, isLoading, isValidating, mutate } = useSWRImmutable(
    id ? endpoints.pop.get({ id, type }) : null,
    request,
  )

  return {
    data: data?.data,
    isError: error,
    isLoading,
    mutate,
    isValidating,
  }
}
